import { Component, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'first-time',
  templateUrl: './first-time.component.html',
  styleUrls: ['./first-time.component.scss'],
})
export class FirstTimeComponent implements OnInit {

  @Output() agreed = new EventEmitter<boolean>()

  public leftShine = './assets/icon/left-shine.svg'
  public rightShine = './assets/icon/right-shine.svg'
  public arrowToon = './assets/icon/arrow-toon.svg'

  constructor() { }

  ngOnInit() {}

  public onDismiss() {
    this.agreed.emit(true)
  }

}
